/**
 * created by li si yi
 * 敏感词设置
 */
import React, {Component} from 'react';
import {Button, message, Pagination, Input, Modal, Form, Select, Popconfirm, Upload} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import {Scrollbars} from "react-custom-scrollbars";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import UploadWall from "../../../components/upload/UploadWall";
import {ECXCEL_TYPE, ECXCEL_TYPE_ORIGINAL} from "../../../constants";

const {Search} = Input;
const {Option} = Select;
export default class SensitiveWordSetting extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabBarList: [ // 选项卡数据
                {
                    key: '0',
                    name: '冻结记录',
                }
            ],
            params: {
                wrong: "",
                correct: "",
                regex: "",
                wrongSource: null,
                type: null,
                size: 10,
                start: 1,
                wrongOrCorrect: ''
            },
            word: '',//切换类型时敏感词回显不消失
            wrongSourceShow: '本地检测',//来源回显
            count: 0,
            columns: [
                {
                    title: '序号',
                    dataIndex: 'serial',
                    key: 'serial',
                    width: 80,
                    ellipsis: true,
                    render: (text, record, index) => (this.state.params.start - 1) * this.state.params.size + (index + 1)
                },
                {
                    title: '敏感词/正则',
                    dataIndex: 'wrong',
                    key: 'wrong',
                    width: 200,
                    // ellipsis: true,
                    render: (text, record) => {
                        return (
                            <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
                                 title={text ? text : '' || record.regex ? record.regex : ""}>{text ? text : ''}{record.regex ? record.regex : ""}</div>
                        )
                    }
                },
                {
                    title: '替换词',
                    dataIndex: 'correct',
                    key: 'correct',
                    width: 200,
                    render: (text) => {
                        return (
                            <div style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>{text ? text : ''}</div>
                        )
                    }
                },
                {
                    title: '类型',
                    dataIndex: 'type',
                    key: 'type',
                    render: (text, record) => {
                        let typeName;
                        switch (text) {
                            case 'SENSITIVE':
                                typeName = '敏感词';
                                break;
                            case 'PRIVACY_INFORMATION':
                                typeName = '隐私信息';
                                break;
                            // case 'MISINFORMATION':
                            //     typeName = '误报词库';
                            //     break;
                            case 'OUTSIDE_CHAIN':
                                typeName = '疑似外链';
                                break;
                            // case 'WRONG_CHARACTER':
                            //     typeName = '错别字';
                            //     break;
                            case 'PERSON_SENSITIVE':
                                typeName = '敏感人物';
                                break;
                            default:
                                typeName = '';
                                break;
                        }
                        return (
                            <span>{typeName}</span>
                        )
                    }
                },
                {
                    title: '来源',
                    dataIndex: 'wrongSource',
                    key: 'wrongSource',
                    render: (text) => {
                        let wrongSource;
                        switch (text) {
                            case 'CLOUD_CHECK':
                                wrongSource = '云端检测';
                                break;
                            case 'LOCAL_CHECK':
                                wrongSource = '本地检测';
                                break;
                            default:
                                wrongSource = '';
                                break;
                        }
                        return (
                            <span>{wrongSource}</span>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (text, record) => {
                        let that = this;
                        return (
                            <div>
                                <span style={{
                                    padding: '3px 10px',
                                    background: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                    color: '#fff',
                                    borderRadius: 5,
                                    marginRight: 10,
                                    cursor: 'pointer'
                                }}
                                      onClick={() => {
                                          this.state.currentClick = 1;
                                          that.edit(record);
                                      }}>编辑</span>
                                <Popconfirm title="确定要删除吗？"
                                            onConfirm={() => {
                                                that.delData(record)
                                            }}
                                            okText="确定"
                                            cancelText="取消">
                                    <span style={{
                                        padding: '3px 10px',
                                        background: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                        color: '#fff',
                                        borderRadius: 5,
                                        cursor: 'pointer'
                                    }}>删除</span>
                                </Popconfirm>
                            </div>
                        )
                    }
                },
            ],
            dataSource: [],
            saveParams: {
                wrong: "",//错误的
                correct: "",//正确的
                suggest: "",
                regex: "",
                wrongSource: "LOCAL_CHECK",
                type: "SENSITIVE"
            },
            visible: false,
            currentSelect: 'SENSITIVE',
            selectedRowKeys: [],
            batchDelData: [],
            currentClick: 0,
            fileList: [],
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDataSource();
    }

    componentWillUnmount() {
    }


    render() {
        return (
            <div className="card-container" style={{margin: '15px', maxHeight: 'calc(100vh - 100px)',}}>
                {/*列表内容*/}
                {this.renderTable()}
            </div>
        )
    }

    // 选项卡
    renderHeader = () => {
        return (
            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: 24}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Button type="primary" style={{marginRight: 10}} onClick={() => {
                        this.state.currentClick = 0;
                        this.showModal();
                    }}>添加敏感词</Button>
                    {
                        this.state.batchDelData.length > 0 ?
                            <Popconfirm title="确定要删除吗？"
                                        onConfirm={() => {
                                            this.delBatch(this.state.batchDelData);
                                        }}
                                        okText="确定"
                                        cancelText="取消">
                                <Button type="primary" style={{marginRight: 10}}>删除敏感词</Button>
                            </Popconfirm> :
                            <Button type="primary" style={{marginRight: 10}} onClick={() => {
                                message.destroy();
                                message.error('请勾选要删除的敏感词！')
                            }}>删除敏感词</Button>
                    }
                    <Button type="primary" style={{marginRight: 10}} onClick={() => {
                        this.exportExcel();
                    }}>导出敏感词</Button>
                    <UploadWall
                        accept={"." + [...ECXCEL_TYPE_ORIGINAL].join(",.")}
                        multiple={false}
                        action="/storage/uploadFile"
                        listType={'list'}
                        // fileList={attach}
                        style={{padding: 'unset'}}
                        customRequest={new ChunkUpload({
                            checkFileURL: "/storage/checkFile",
                            checkChunkURL: "/storage/checkChunk",
                            uploadChunkURL: "/storage/uploadChunk",
                            chunkUploadOverURL: "/storage/chunkIsUploadOver",
                            mergeChunksURL: "/storage/mergeChunk"
                        }).start}
                        uploadBtnName={<Button type="primary" style={{marginTop: '10px'}}>导入敏感词</Button>}
                        beforeUpload={this.beforeUpload}
                        onChange={this.onChange}
                        showPercent={false}
                    />
                </div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Search placeholder={'请输入敏感词/正则'} value={this.state.params.wrongOrCorrect} onChange={(e) => {
                        this.setState({
                            params: {
                                ...this.state.params,
                                wrongOrCorrect: e.target.value
                            }
                        });
                    }} onSearch={value => {
                        this.state.params.start = 1;
                        this.getDataSource();
                    }} style={{width: 224}}/>
                    <Button type="primary" style={{marginLeft: 10}} onClick={() => {
                        this.state.params = {
                            wrong: "",
                            correct: "",
                            regex: "",
                            wrongSource: null,
                            type: null,
                            size: 10,
                            start: 1,
                        };
                        this.getDataSource();
                    }}>重置</Button>
                </div>
            </div>
        )
    };
    // 敏感词列表
    renderTable = () => {
        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                this.state.batchDelData = selectedRows;
                this.state.selectedRowKeys = selectedRowKeys;
                this.setState({})
            }

        };
        // 获取当前tab参数
        return (
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '5px',
                width: '100%'
            }} className={"SensitiveWordSetting"}>
                <div style={{padding: '0 32px', width: '100%', paddingTop: 14}}>
                    {/*头部*/}
                    {this.renderHeader()}
                    <Scrollbars  autoHeight autoHeightMax={"calc(100vh - 257px )"}>
                        <BaseTable rowKey="id" rowSelection={rowSelection} dataSource={this.state.dataSource}
                                   columns={this.state.columns}
                                   pagination={false}/>
                    </Scrollbars>
                    <style>{`
                    .SensitiveWordSetting .ant-table-placeholder{
                       display:flex;
                       justify-content: center;
                       align-items: center;
                    //    height:500px;
                       border-bottom:none;
                    }
                `}</style>
                </div>
                {/*分页*/}
                {this.renderPagination()}
                {/*新增*/}
                {this.renderModal()}
            </div>
        )
    };
    //弹窗
    renderModal = () => {
        let {saveParams} = this.state;
        return (
            <Modal title={'敏感词设置'}
                   visible={this.state.visible}
                   onOk={this.handleOk}
                   onCancel={this.handleCancel}>
                <Form labelCol={{span: 4}} wrapperCol={{span: 10}} style={{textAlign: "center"}}>
                    <Form.Item label="类型" required style={{marginTop: 10}}>
                        <Select style={{width: 375}} value={this.state.currentSelect}
                                onChange={(value) => this.handleChange(value)}>
                            <Option value={'SENSITIVE'}>敏感词</Option>
                            <Option value={'OUTSIDE_CHAIN'}>疑似外链</Option>
                            <Option value={'PRIVACY_INFORMATION'}>隐私信息</Option>
                            <Option value={'PERSON_SENSITIVE'}>敏感人物</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label={'敏感词'} required style={{marginTop: 10}}>
                        <Input maxLength={200}
                               value={this.state.currentClick === 0 ? this.state.word : saveParams.regex || saveParams.wrong}
                               onChange={this.changeWord} placeholder="请输入敏感词"
                               style={{width: 375, background: "rgba(0, 80, 179, 0.04)"}}/>
                    </Form.Item>
                    <Form.Item label="替换词" style={{marginTop: 10}}>
                        <Input maxLength={200} value={saveParams.correct} onChange={(e) => {
                            this.setState({
                                saveParams: {
                                    ...this.state.saveParams,
                                    correct: e.target.value
                                }
                            })
                        }} placeholder="请输入替换词" style={{width: 375, background: "rgba(0, 80, 179, 0.04)"}}/>
                    </Form.Item>
                    <Form.Item label="来源" style={{marginTop: 10}}>
                        <Input disabled={true} value={this.state.wrongSourceShow} placeholder="请输入来源"
                               style={{width: 375, background: "rgba(0, 80, 179, 0.04)"}}/>
                    </Form.Item>
                </Form>
            </Modal>
        )
    };

    showModal = () => {
        let {saveParams} = this.state;
        this.setState({
            visible: true,
            word: '',
            saveParams: {
                wrong: "",//错误的
                correct: "",//正确的
                suggest: "",
                regex: "",
                wrongSource: "LOCAL_CHECK",
                type: "SENSITIVE",
            },
            currentSelect: 'SENSITIVE',
            wrongSourceShow: '本地检测'
        });
    };
    // 新增、编辑确定
    handleOk = () => {
        message.destroy();
        let {saveParams, currentClick} = this.state;
        if (saveParams.type === 'OUTSIDE_CHAIN' || saveParams.type === 'PRIVACY_INFORMATION') {
            this.state.saveParams.regex = this.state.word;
        } else {
            this.state.saveParams.wrong = this.state.word;
        }

        if (saveParams.wrong && saveParams.wrong.length > 200 || saveParams.regex && saveParams.regex.length > 200) {
            message.error('敏感词长度不能超过200！');
            return
        }
        if (saveParams.correct && saveParams.correct.length > 200) {
            message.error('替换词长度不能超过200！');
            return
        }
        if (((saveParams.wrong === saveParams.correct) && saveParams.wrong && saveParams.correct) || (saveParams.regex === saveParams.correct) && saveParams.regex && saveParams.correct) {
            message.error('错词不能与替换词相同！');
            return
        }
        if (saveParams.type === 'SENSITIVE' || saveParams.type === 'PERSON_SENSITIVE') {
            if (!saveParams.wrong) {
                message.error('敏感词不能为空！');
                return
            }
        } else {
            if (!saveParams.regex) {
                message.error('敏感词不能为空！');
                return
            }
        }
        if (currentClick === 0) {
            this.addSave(saveParams);
        } else if (currentClick === 1) {
            this.editData(saveParams);
        }
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    //切换类型
    handleChange(value) {
        this.setState({
            currentSelect: value,
            saveParams: {
                ...this.state.saveParams,
                type: value
            }
        });
    }

    changeWord = (e) => {
        let {saveParams} = this.state;
        this.setState({
            word: e.target.value,
        });
        if (this.state.currentClick === 1) {
            if (saveParams.type === 'OUTSIDE_CHAIN' || saveParams.type === 'PRIVACY_INFORMATION') {
                this.setState({
                    saveParams: {
                        ...this.state.saveParams,
                        regex: e.target.value,
                        wrong: '',
                    }
                })
            } else {
                this.setState({
                    saveParams: {
                        ...this.state.saveParams,
                        wrong: e.target.value,
                        regex: '',
                    }
                })
            }
        }
    };

    //导出敏感词
    exportExcel() {
        message.destroy();
        this.getDataSource((dataSourceAll) => {
            if (!(dataSourceAll && dataSourceAll.length)) {
                message.error('无敏感词，无法导出!')
            }
            this.request({
                url: '/cm-sites-sys/wrongWord/wrongWordExpot',
                method: 'downloadPost',
                contentType: 'json',
                body: dataSourceAll,
                callBack: (res) => {
                    if (res) {
                        message.success('导出成功')
                    } else {
                        message.error('导出失败!')
                    }
                }
            })
        });
    }

    //导入敏感词
    importExcel(file) {
        // console.log(file.response, file.response.data.md5);
        if (!file.response && !file.response.data && !file.response.data.md5) {
            return
        }
        let params = {
            md5: file && file.response && file.response.data && file.response.data.md5 ? file.response.data.md5 : file.response.md5
        };
        this.request({
            url: '/cm-sites-sys/wrongWord/wrongWordImportByMd5',
            method: 'post',
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success('导入成功');
                    this.getDataSource();
                } else {
                    message.error(res.message)
                }
            }, serverVerify: {
                isShowErrorMsg: false,
                serverErrorCallBack: () => {
                    message.error('文件内容与导入系统要求内容不符合！');
                }
            },
            errorCallBack: () => {
                message.error('文件内容与导入系统要求内容不符合！');
            }
        })
    }

    // 上传excel
    onChange = (info) => {
        console.log(info);
        if (info.file.status === 'done') {
            this.importExcel(info.file);
        }
        info.file = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.md5 = info.file.response && info.file.response.md5;
                // item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.setState({
            fileList: info.fileList,
        })
    };
    // 分页
    renderPagination = () => {
        let {params, count} = this.state;
        let {start, size} = params;

        return (
            <>
                {
                    count === 0 ? null : <div className={'pagination'} style={{paddingBottom: 17,paddingTop: 17}}>
                        <div style={{padding: "0 10px 0"}}>共{count}条数据</div>
                        <Pagination
                            showSizeChanger
                            current={start}
                            pageSize={size}

                            total={count}
                            showQuickJumper={true}
                            onChange={this.pageChange}
                            onShowSizeChange={this.pageChange}
                        />
                    </div>
                }
            </>
        )
    };

    // 获取选项卡内容数据
    getDataSource(callback) {
        let params;
        if (callback) {
            params = {
                wrong: "",
                correct: "",
                regex: "",
                wrongSource: null,
                type: null,
                size: 0,
                start: 0,
                wrongOrCorrect: ''
            }
        } else {
            params = this.state.params;
        }
        this.request({
            url: '/cm-sites-sys/wrongWord/conditionQuery',
            body: params,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                let dataSource = [];
                let count = 0;
                if (res) {
                    this.setState(
                        {selectedRowKeys: []}
                    )
                    dataSource = res.data;
                    count = res.count;
                    if (callback) {
                        callback(dataSource)
                    }

                } else {
                    message.error("数据获取失败！");
                }
                if (!callback) {
                    this.setState({dataSource, count});
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };

    // 分页改变
    pageChange = (start, size) => {
        let {params} = this.state;
        // 获取当前tab参数
        params.start = start;
        params.size = size;
        this.setState({batchDelData: [], selectedRowKeys: []});
        this.getDataSource();
    };
    // 新增保存
    addSave = (saveParams) => {
        message.destroy();
        this.request({
            url: '/cm-sites-sys/wrongWord/save',
            body: saveParams,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    message.success('添加成功');
                    this.state.params.start = 1;
                    this.getDataSource();
                } else {
                    message.error("添加失败！");
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };

    //删除单条
    delData(record) {
        message.destroy();
        let params = {id: record.id};
        this.request({
            url: '/cm-sites-sys/wrongWord/deleteById',
            body: params,
            callBack: (res) => {
                if (res) {
                    if (this.state.dataSource.length === 1 && this.state.params.start > 1) {
                        this.pageChange(this.state.params.start - 1, this.state.params.size)
                    } else {
                        this.pageChange(this.state.params.start, this.state.params.size)
                    }
                    message.success('删除成功');
                }
            }
        })
    };

    //删除多个
    delBatch(batchDelData) {
        message.destroy();
        let params = [];
        batchDelData.map(item => {
            params.push(item.id)
        });
        this.request({
            url: '/cm-sites-sys/wrongWord/deleteByIds',
            body: params,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    let page = this.state.params.start;
                    let size = this.state.params.size;
                    let count = this.state.count;
                    let pageSum = Math.ceil(count / size);
                    let dataLength = this.state.dataSource.length - batchDelData.length;
                    if (dataLength === 0) {
                        if (pageSum == page) {	//最后一页
                            page = page > 1 ? page - 1 : 1
                        } else {
                            page = page
                        }
                    }
                    this.pageChange(page, size)


                }
            }
        })
    }

    //编辑
    edit(record) {
        let {saveParams} = this.state;
        this.state.visible = true;
        this.state.currentSelect = record.type;
        saveParams.id = record.id;
        saveParams.wrong = record.wrong;
        saveParams.correct = record.correct;
        saveParams.suggest = "";
        saveParams.regex = record.regex;
        saveParams.wrongSource = record.wrongSource;
        saveParams.type = record.type;
        if (this.state.saveParams.wrongSource === 'LOCAL_CHECK') {
            this.setState({
                wrongSourceShow: '本地检测',
            })
        } else if (this.state.saveParams.wrongSource === 'CLOUD_CHECK') {
            this.setState({
                wrongSourceShow: '云端检测',
            })
        }
        if (saveParams.type === 'OUTSIDE_CHAIN' || saveParams.type === 'PRIVACY_INFORMATION') {
            this.setState({
                word: this.state.saveParams.regex,
            })
        } else {
            this.setState({
                word: this.state.saveParams.wrong,
            })
        }
        this.setState({})
    }

    // 编辑
    editData(saveParams) {
        message.destroy();
        this.request({
            url: '/cm-sites-sys/wrongWord/edit',
            body: saveParams,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    message.success('修改成功');
                    this.getDataSource();
                }
            }
        })
    }

    beforeUpload = file => {
        const isJpgOrPng = file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        if (!isJpgOrPng) {
            message.error("请上传excel！");
            return false
        }
        return true;
    };
};

SensitiveWordSetting.defaultProps = {};
SensitiveWordSetting.propTypes = {};